"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InsuranceTable = (function () {
    function InsuranceTable() {
        this._startAge = 0;
        this._costArray = [];
    }
    InsuranceTable.prototype.initialise = function (startAge, costArray) {
        this._startAge = startAge;
        this._costArray = costArray;
    };
    InsuranceTable.prototype.cost = function (age) {
        var index = age - this._startAge;
        if (index < 0) {
            index = 0;
        }
        else if (index >= this._costArray.length) {
            index = this._costArray.length - 1;
        }
        return this._costArray[index];
    };
    return InsuranceTable;
}());
exports.InsuranceTable = InsuranceTable;
//# sourceMappingURL=InsuranceTable.js.map